import React from 'react'
import getShowtime from '../func/getShowtime';


const MovieTimesPeriodeDaysItemsDesktop = ({performances, additionalClass=''}) => {
    return performances.map((performance, index) => {
        const { timeUtc } = performance
    
        return (
            <div className={'show-wrapper cursor-pointer' + additionalClass} key={index}>
                <span className="text-bold-grey showtime">{getShowtime(timeUtc)}</span>
            </div>
        )
    })
}

export default MovieTimesPeriodeDaysItemsDesktop